// src/frontend/data/books/DarkForest/data/cap19.js

const CAP19 = {
  id: 17,
  title: "Capítulo 18-Firmas contraintuitivas",
  sections: [
    {
      heading: "¿Por qué la seguridad de las firmas es tan crítica?",
      text: [
        "La seguridad en las firmas (Signature Security) es probablemente uno de los temas más críticos y menos comprendidos del mundo Web3.",
        "Existen MUCHÍSIMAS trampas, especialmente en el comercio de NFTs y en el uso de DApps. Las personas suelen conocer lo superficial (apretar 'Sign'), pero no entienden qué están autorizando realmente.",
        "La mayoría de los hackeos NFT entre 2021 y 2023 no fueron por vulnerabilidad de contratos, sino por firmas ciegas (blind signing).",
        "La razón principal es que **pocas personas entienden qué están firmando realmente** y cómo esa firma puede ser usada para robar activos, mover NFTs, o ejecutar funciones sin su permiso."
      ]
    },

    {
      heading: "Principio de seguridad Nº1:",
      text: [
        "**WHAT YOU SEE IS WHAT YOU SIGN (Lo que ves es lo que firmas)**",
        "Cuando recibes una solicitud de firma, el contenido que ves en pantalla debe ser EXACTAMENTE lo que entiendes que va a ocurrir.",
        "Si firmas algo que no comprendes, estás confiando ciegamente y posiblemente entregando control sobre tus activos.",
        "Una firma válida puede autorizar acciones como mover tus NFTs, transferir tus tokens ERC20, aprobar gasto ilimitado o incluso otorgar control sobre toda tu wallet."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/metamask_sign.jpg",
        alt: "Ventana básica de firma en MetaMask",
        caption: "Ejemplo de ventana de firma donde el usuario no comprende completamente qué está autorizando."
      }
    },

    {
      heading: "Firmas ciegas (Blind Signing): el enemigo silencioso",
      text: [
        "Muchos hackeos no ocurrieron por contratos inseguros, sino porque el usuario firmó **sin ver ni entender el contenido real** de la firma.",
        "Esto es lo que llamamos blind signing (firmas ciegas): se firma un hash, un mensaje técnico, o un texto confuso sin entender su consecuencia real.",
        "Los atacantes utilizan páginas falsas (phishing) para pedir firmas idénticas a las que pediría una DApp legítima.",
        "El usuario cree que está firmando un 'login', pero en realidad está autorizando el traspaso de un NFT, un swap directo o un withdraw completo."
      ]
    },

    {
      heading: "Caso real: Hackeo masivo de OpenSea (Febrero 2022)",
      text: [
        "El 20 de febrero de 2022, se registró uno de los hackeos NFT más grandes en la historia de OpenSea.",
        "Miles de usuarios firmaron mensajes aparentemente inofensivos, sin saber que estaban autorizando transferencias de sus NFTs a billeteras de los atacantes.",
        "El proceso fue el siguiente:",
        "1️⃣ El hacker genera un mensaje para firmar (listing de venta),",
        "2️⃣ Lo transforma en hash usando Keccak256 (estándar en Ethereum),",
        "3️⃣ Lo coloca en un sitio phishing, donde pide la firma,",
        "4️⃣ El usuario firma — ¡boom! — sus NFTs son transferidos automáticamente.",
        "Ese día, se robaron NFTs de BAYC, Azuki, CloneX, Doodles, y muchos otros proyectos top."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/ChatGPT%20Image%2017%20nov%202025%2C%2023_10_22.png",
        alt: "Ejemplo real de popup de firma engañosa en OpenSea",
        caption: "El popup no mostraba claramente qué se estaba firmando. Después, OpenSea adoptó EIP-712 para firmas más legibles."
      }
    },

    {
      heading: "¿Qué información realmente ves en MetaMask?",
      text: [
        "Cuando firmas sin EIP-712, MetaMask solo muestra:",
         "🔹 La dirección que firma",
         "🔹 El sitio web origen",
         "🔹 Un hash (ilegible)",
         "🔹 Botón `Sign`",
        "¿Cómo puedes saber si estás autorizando una compra, una transferencia o una aprobación sin límite?",
        "No puedes. Esa es la esencia de la blind signing.",
        "Y peor aún: muchos usuarios creen que si ‘no hay gas’, entonces no hay riesgo. ¡FALSO! Las firmas de aprobación NO consumen gas del usuario, pero sí otorgan permisos críticos."
      ]
    },

    {
      heading: "¿Por qué ocurre? No hay política de mismo origen (Same-Origin Policy)",
      text: [
        "Las firmas NO están ligadas al dominio desde donde se originan.",
        "Esto significa que puedes firmar algo en `fake-opensea.io`, pero los atacantes pueden usar esa firma en el verdadero `opensea.io`.",
        "Por eso el phishing es tan peligroso: puedes firmar en un sitio falso, pero el efecto es válido en el sitio real.",
        "Si las firmas respetaran same-origin policy como los navegadores, este ataque no sería posible. Pero hoy, aún no lo es."
      ]
    },

    {
      heading: "Herramientas para identificar y cancelar permisos peligrosos",
      text: [
        "Si ya has firmado algo sospechoso, aún puedes revocar esos permisos antes de que te roben.",
        "Herramientas para revocar permisos (Token Approval Checkers):",
         "🔹 Ethereum: https://etherscan.io/tokenapprovalchecker",
         "🔹 Polygon: https://polygonscan.com/tokenapprovalchecker",
         "🔹 BSC: https://bscscan.com/tokenapprovalchecker",
         "🔹 Cronos: https://cronoscan.com/tokenapprovalchecker",
         "🔹 Snowtrace: https://snowtrace.io/tokenapprovalchecker",
        "",
        "Otras herramientas útiles:",
         "🔹 https://revoke.cash",
         "🔹 https://rabby.io/ (wallet con cancelación integrada de autorizaciones)",
        "",
        "Si ves tokens con `Unlimited Spend`. ¡REVÓCALOS INMEDIATAMENTE!"
      ]
    },

    {
      heading: "Conclusión y consejos prácticos",
      text: [
        "👉 Nunca firmes algo que no entiendas perfectamente.",
        "👉 Aprende a leer mensajes EIP-712, son más visuales y seguros.",
        "👉 Si un popup no muestra claramente qué se firma → CANCELA.",
        "👉 Revisa tus aprobaciones cada cierto tiempo.",
        "👉 Usa wallets como Rabby o Frame que muestran el riesgo antes de firmar.",
        "",
        "🔐 Recuerda: una sola firma malintencionada puede vaciar toda tu billetera."
      ]
    },

    {
      heading: "Recursos recomendados",
      text: [
        "📘 Para aprender más:",
        "https://github.com/evilcos/darkhandbook",
        "",
        "Si puedes leer y entender todo ese repositorio, la seguridad Web3 nunca más será un misterio para ti."
      ]
    },
    {
      heading: "¿Qué es el riesgo contraintuitivo?",
      text: [
        "El riesgo contraintuitivo ocurre cuando nuestra experiencia previa nos da una falsa sensación de seguridad. Creemos que sabemos cómo funcionan los ataques, pero en un nuevo ecosistema (como Solana, Avalanche, Sui, Aptos, etc.), las reglas cambian.",
        "Por ejemplo, si eres usuario avanzado de Ethereum, puedes pensar que dominas los riesgos de firmar transacciones y que es casi imposible caer en una trampa, porque ya has visto cientos de intentos de phishing en DeFi y NFT.",
        "Ese exceso de confianza es exactamente lo que explotan los atacantes. Cuando llegas a otro ecosistema como Solana, tus intuiciones pueden fallar, y esa desconexión entre tu experiencia previa y la nueva realidad abre una puerta peligrosa."
      ]
    },

    {
      heading: "¿Cómo funciona en la práctica?",
      text: [
        "Un ataque real ocurrido el 5 de marzo de 2022 en Solana demostró perfectamente esta idea.",
        "Los atacantes enviaron NFTs mediante airdrops a miles de usuarios. En la descripción del NFT había un enlace que decía pertenecer a un proyecto exclusivo (www_officialsolanarares_net).",
        "Muchos usuarios hicieron clic, conectaron sus wallets Phantom (u otras), y al presionar el botón “Mint”, apareció una solicitud de aprobación aparentemente normal.",
        "El popup era simple, limpio y no mostraba información alarmante. Muchos aprobaron. En cuestión de segundos, sus SOL fueron transferidos directamente al atacante."
      ],
      // Espacio para insertar imagen del NFT (Figure 1)
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/solana_nft_phishing.jpg",
        alt: "NFT airdrop con enlace de phishing",
        caption: "Ejemplo de NFT malicioso distribuido por airdrop con enlace de phishing."
      }
    },

    {
      heading: "¿Qué ocurrió realmente detrás?",
      text: [
        "Cuando el usuario presionaba “Approve”, no estaba minting nada. En realidad, estaba autorizando un contrato malicioso para enviar sus fondos.",
        "El contrato involucrado era: 3VtjHnDuDD1QreJiYNziDsdkeALMT6b2F9j3AXdL4q8v",
        "Este contrato ejecutaba una función llamada ‘SOL Transfer’, que vaciaba casi todo el balance del usuario y enviaba los fondos directamente a los atacantes.",
        "El phishing se mantuvo activo durante varios días, y el número de víctimas continuó aumentando."
      ],
      // Espacio para insertar imagen del popup de aprobación (Figure 2)
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/solana_nft_phishing.jpg",
        alt: "Ventana de aprobación engañosa",
        caption: "Ventana de aprobación en Phantom. Parecía inofensiva, pero otorgaba control total al contrato malicioso."
      }
    },

    {
      heading: "¿Por qué este ataque es contraintuitivo?",
      text: [
        "Porque los usuarios experimentados de Ethereum ‘sabían’ que firmar un approve no permite robar el token nativo (ETH). En Ethereum, approve afecta solo tokens ERC-20 y NFTs, pero no al ETH.",
        "Sin embargo, en Solana no se aplica la misma regla. En Solana, una aprobación puede permitir transferir los activos nativos (SOL), aunque el usuario crea que está firmando algo inofensivo.",
        "Esa diferencia entre expectativas (Ethereum) y realidad (Solana) es lo que hace el ataque contraintuitivo y tan peligroso."
      ]
    },

    {
      heading: "Segundo problema: diseño de las wallets",
      text: [
        "En Ethereum, wallets como MetaMask suelen mostrar información más explícita sobre lo que estás firmando.",
        "Pero en Solana, algunas wallets muy populares (como Phantom, en ese momento) no seguían el principio de seguridad ‘What you see is what you sign’.",
        "Esto significa que el usuario no veía claramente qué estaba autorizando, y la wallet no le advertía sobre permisos peligrosos o transferencias potenciales.",
        "Falta de advertencia + funcionamiento distinto del ecosistema = trampa perfecta."
      ]
    },

    {
      heading: "Lecciones clave que debes recordar",
      text: [
        "1️⃣ Nunca asumas que las mismas reglas aplican en todas las blockchains.",
        "2️⃣ No confíes en popups ‘limpios’. La ausencia de detalles puede ser una señal de riesgo.",
        "3️⃣ Si recibes NFTs por airdrop, NUNCA interactúes con los enlaces que contienen.",
        "4️⃣ Entiende cómo funciona el modelo de permisos en cada blockchain (Ethereum ≠ Solana).",
        "5️⃣ Aplica la regla general: Si no entiendes qué estás firmando, simplemente no lo firmes."
      ]
    },

    {
      heading: "Conclusión del ataque contraintuitivo",
      text: [
        "Los atacantes no siempre van por los usuarios nuevos. A veces atacan a los más experimentados, usando justamente su exceso de confianza.",
        "Aprende constantemente. Lo que es seguro hoy, puede no serlo mañana. Lo que es seguro en Ethereum, puede ser peligroso en Solana.",
        "El conocimiento técnico NO es suficiente. Debes aprender a detectar patrones de engaño.",
        "El enemigo no siempre es más inteligente que tú, pero solo necesita que te confíes una vez."
      ]
    }
  ]
};

export default CAP19;
